import { stdObject } from "../../../../data/types/stdObject";

export const addNewOffer = (
  country: string,
  data: stdObject,
  params: stdObject,
) => {
  const { windowValues2, setWindowValues2 } = params;
  let tempValues = windowValues2;
  if (!(country in tempValues.PRE.offers)) {
    tempValues.PRE.offers[country] = [];
  }
  if (!("DATOFE" in data)) {
    data.DATOFE = "0";
  }
  if (!("TIPOFE" in data)) {
    data.TIPOFE = "0";
  }
  if (!("TAROFE" in data)) {
    data.TAROFE = "0";
  }
  tempValues.PRE.offers[country].push({ ...data, ACTOFE: "1" });
  setWindowValues2({ ...tempValues });
};
